import { gql, useMutation } from '@apollo/client'
import { Button } from '@mui/material'
import { Timeline } from 'utils/__generated__/graphql'

import { TIMELINE_FRAGMENT } from '../constants'

const UPDATE_TIMELINE = gql`
  ${TIMELINE_FRAGMENT}
  mutation UPDATE_TIMELINE($id: ID!, $timeline: TimelineInput!) {
    updateTimeline(id: $id, timeline: $timeline) {
      ...TimelineFragment
    }
  }
`

function Publish({ timeline }: { timeline: Timeline }) {
  const [updateTimeline] = useMutation(UPDATE_TIMELINE)

  const handleTimeline = () => {
    updateTimeline({
      variables: {
        id: timeline.id,
        timeline: { isPublished: !timeline.isPublished },
      },
    })
  }

  return (
    <Button
      color={timeline.isPublished ? 'error' : 'primary'}
      onClick={handleTimeline}
      size="small"
    >
      {timeline.isPublished ? 'Unpublish' : 'Publish'}
    </Button>
  )
}

export default Publish
